import { SCALAR_UNIT } from "../unit-system";
/**
 * `base` raised to `exponent`. Both must be plain numbers: a unit raised to a
 * power (m² from m, or m^0.5) has no representation in the unit system, so a
 * unit-carrying argument is rejected rather than silently dropped. A result
 * that is not a finite number (0 to a negative power, a fractional power of a
 * negative base) is an error, never Infinity or NaN.
 */
class PowFunction {
    signature = {
        name: "pow",
        parameters: [
            { name: "base", type: "scalar", description: "A unitless number" },
            { name: "exponent", type: "scalar", description: "A unitless number" },
        ],
        returnType: "scalar",
        description: "Raise a unitless number to a power",
        examples: [
            "pow(10, row.dilution)",
            "avg(row.plate_1, row.plate_2) / pow(10, row.dilution)",
        ],
        category: "math",
    };
    execute(args, context) {
        const [base, exponent] = args;
        for (const [label, arg] of [
            ["base", base],
            ["exponent", exponent],
        ]) {
            const unit = arg.unit ?? SCALAR_UNIT;
            if (unit !== SCALAR_UNIT) {
                return context.createError("UnsupportedUnitOperation", `pow() needs a unitless ${label}, but got a value in "${unit}".`);
            }
        }
        const value = Math.pow(base.value, exponent.value);
        if (!Number.isFinite(value)) {
            return context.createError("InvalidArgumentType", `pow(${base.value}, ${exponent.value}) is not a finite number.`);
        }
        return { type: "scalar", value, unit: SCALAR_UNIT };
    }
}
export const mathFunctions = [new PowFunction()];
//# sourceMappingURL=math-functions.js.map